import { Fragment } from 'react'
import cx from 'classnames'
import styles from './MultiLineText.css'
import _ from 'lodash'
import PropTypes from 'prop-types'

/**
 * 用 <br /> 取代 \n 斷行
 *
 * @param {string} [content='']
 * @returns
 */
const getSplitContentByNewline = (content = '') => {
  const splitContent = content
    .split('\n')
    .map(
      (item, index) => (
        <Fragment key={index}>
          {item}
          <br />
        </Fragment>
      ))

  return splitContent
}

/**
 * 用 <ul><li> 條列式取代 \n 斷行
 *
 * @param {string} [content='']
 * @returns
 */
const getSplitContentByLi = (content = '') => {
  // handle edge case, such like "i am a string \n\n 2nd line\n\n\n\n\n\n\n 3rd line \n\n\n\n\n\n"
  let filteredContent = content.replace(/\n{2,}/g, '\n') // merge repeat '\n' if exists
  filteredContent = filteredContent.replace(/\n+$/, '') // remove all '\n' at end of string
  const splitContent = filteredContent
    .split('\n')
    .map(
      (item, key) => (
        <li
          key={key}
        >
          {item}
        </li>
      ))

  return splitContent.length > 1
    ? (
      <ul
        className={cx(styles.MultiLineText)}
      >
        {splitContent}
      </ul>
    )
    : content
}

const getContent = props => {
  let contentFromProps = props.content || _.get(props, 'input.value', '')

  if (_.isArray(contentFromProps)) {
    contentFromProps = contentFromProps[0]
  }

  if (!contentFromProps) {
    return '--'
  } else {
    const showListItem = props.showListItem || ''
    switch (showListItem) {
      case 1:
        return getSplitContentByLi(contentFromProps)
      case '':
      default:
        return getSplitContentByNewline(contentFromProps)
    }
  }
}

const MultiLineText = (props = {}) => {
  const content = getContent(props)
  return (
    <div
      data-role='multi-line-text'
      className={cx(styles.MultiLineText, props.className)}
    >
      {content}
    </div>
  )
}

MultiLineText.propTypes = {
  content: PropTypes.string,
  input: PropTypes.object
}

export default MultiLineText
